var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-aux-alarm"},[_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('messages.alarms.serviceAUXAlarm.description'))+"\n  ")]),_c('alarm-status',{attrs:{"alarm":_vm.alarm,"alarm-active":_vm.computedAlarmIsActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }